import { z } from "zod";
import {
  EXPERIMENT_ENTITY_PREFIX,
  isValidPrefixedKsuid,
} from "@/utils/ksuidGenerator";
import { parseCatalogEntityPayload } from "@/lib/toolCardSchemas/parseCatalogEntityPayload";

const DATA_TRACKER_ENTITY_PREFIX = "dtk_";

const prefixedKsuid = (prefix: string, label: string) =>
  z.string().refine((id) => isValidPrefixedKsuid(id, prefix), {
    message: `Invalid ${label} public ID`,
  });

export const LockTrackerPayloadSchema = z.object({
  experimentPublicId: prefixedKsuid(EXPERIMENT_ENTITY_PREFIX, "experiment"),
  experimentTitle: z.string().min(1).optional(),
  trackerPublicId: prefixedKsuid(DATA_TRACKER_ENTITY_PREFIX, "tracker").nullish(),
  trackerRowCount: z.number().int().min(0),
});

export const LockTrackerResolveSchema = z.object({});

export type LockTrackerPayload = z.infer<typeof LockTrackerPayloadSchema>;
export type LockTrackerResolve = z.infer<typeof LockTrackerResolveSchema>;

export type LockTrackerToolResult = {
  toolCallId: string;
};

export type LockTrackerArgs = {
  entities?: Array<{
    type?: string;
    experimentPublicId?: string;
    experimentTitle?: string;
    trackerPublicId?: string;
    trackerRowCount?: number;
    toolInvoke?: { toolCallId?: string };
  }>;
  experimentPublicId?: string;
  experimentTitle?: string;
  trackerPublicId?: string;
  trackerRowCount?: number;
};

export function parseLockTrackerPayload(args: unknown, toolCallId?: string) {
  return parseCatalogEntityPayload(
    LockTrackerPayloadSchema,
    "lock_tracker",
    args,
    toolCallId,
    (entity) => ({
      experimentPublicId: entity.experimentPublicId,
      experimentTitle: entity.experimentTitle,
      trackerPublicId: entity.trackerPublicId,
      trackerRowCount: entity.trackerRowCount,
    }),
  );
}
